import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { selectOwnUserHasCapabilityTickets } from 'flow/selectors/TicketsSelectors';
import { ButtonType } from './types';

interface Props {
    buttonType: ButtonType;
}

// Stands in while it's unknown whether the call record has a ticket, so the slot
// doesn't show the wrong action first. The capability check mirrors
// ButtonCreateTicket's: without it the placeholder can resolve to nothing.
const ButtonCreateShowTicketSkeleton = ({ buttonType }: Props) => {
    const { i18next } = useAppContext();
    const hasCapabilityTickets = useAppSelector(
        selectOwnUserHasCapabilityTickets,
    );

    if (!hasCapabilityTickets) return null;

    // No placeholder shape worth holding open for a menu item or a bare icon.
    if (buttonType !== 'iconText') return null;

    // Both labels are measured so the footprint is the wider one in any locale and
    // the resolved button can only shrink into it. Geometry copied from ButtonBase
    // and its 1.5rem Icon — keep in sync.
    return (
        <div className="animate-fade flex h-10 items-center gap-1 rounded bg-gray-200 px-3 text-xs font-bold text-gray-300 antialiased">
            <div className="size-6 rounded-sm bg-current" />
            <span className="relative grid">
                <span className="invisible col-start-1 row-start-1">
                    {i18next.t('tickets.ticket.create_ticket')}
                </span>
                <span className="invisible col-start-1 row-start-1">
                    {i18next.t('tickets.ticket.show_ticket')}
                </span>
                <span className="absolute inset-0 my-auto h-3 rounded-sm bg-current" />
            </span>
        </div>
    );
};

export default ButtonCreateShowTicketSkeleton;
